import { EnvironmentConfig } from '../app/core/config/environment.config';

export const environment: EnvironmentConfig = {
  production: true,
};
